<div class="shopping-cart">
  <div class="header">
    <h4 class="bold mb-3">{{ "shoppingCart.title" | translate }}</h4>
  </div>

  @if (showCampaignCodeRow()) {
    <div class="row">
      <div class="col-12 col-lg-8">
        <vw-text-box
          [label]="'shoppingCart.campaignCode.title' | translate"
          [parentForm]="campaignCodeForm"
          [formControlProp]="'campaignCode'"
          [labelClass]="'primary'"
          [type]="'text'"
          [id]="'campaign-code'"
        ></vw-text-box>
      </div>
      <div class="col-12 col-lg-4 mt-auto mb-3">
        <vw-button
          [text]="
            (!!shoppingCartService.isCampaignCodeApplied()
              ? 'shoppingCart.campaignCode.remove'
              : 'shoppingCart.campaignCode.apply'
            ) | translate
          "
          [primary]="true"
          [disabled]="
            !shoppingCartService.isCampaignCodeApplied() &&
            (!campaignCodeForm.controls.campaignCode.value?.trim() ||
              !campaignCodeForm.controls.campaignCode.dirty)
          "
          (click$)="validateAndApplyOrRemoveCampaignCode()"
        ></vw-button>
      </div>
    </div>

    @if (
      campaignCodeForm.controls.campaignCode.dirty && isInvalidCampaignCode()
    ) {
      <div class="row">
        <vw-alert
          [message]="'shoppingCart.campaignCode.invalid' | translate"
          type="danger"
        ></vw-alert>
      </div>
    }
  }

  <div class="content">
    @if (!shoppingCartService.shoppingCart()?.shoppingCartItems?.length) {
      <vw-alert
        type="info"
        [message]="'infoMessages.shoppingCartEmpty' | translate"
      >
      </vw-alert>
    }

    @if (!modelAndDealerService.selectedDealer) {
      <vw-alert
        type="info"
        [message]="'infoMessages.noDealerSelected' | translate"
      >
      </vw-alert>
    }

    @if (shoppingCartService.productExceptions().length) {
      <vw-alert [type]="'info'">
        <i class="fal fa-exclamation-triangle me-1"></i>
        <span>{{ "shoppingCart.productsDontMatchMessage" | translate }}</span>
      </vw-alert>
    }

    @if (
      !!channelRequestService.channelRequest &&
      !!channelRequestService.channelRequest.shoppingCart &&
      !!channelRequestService.channelRequest.shoppingCart.vehicle &&
      !channelRequestService.channelRequest.shoppingCart.vehicle.vin &&
      !channelRequestService.channelRequest.shoppingCart.vehicle.licensePlate
    ) {
      <vw-alert
        [type]="'info'"
        [message]="'infoMessages.vehicleSelectedByModel' | translate"
      >
      </vw-alert>
    }

    @if (shoppingCartService.hasItems()) {
      <div class="products">
        <div class="header">
          <span class="order">{{ "shoppingCart.order" | translate }}</span>
        </div>
        @for (
          i of shoppingCartService.shoppingCart()?.shoppingCartItems;
          track i
        ) {
          <div class="product">
            @if (i.product) {
              <div class="row align-items-start align-items-sm-center">
                <div class="col-3 my-2">
                  <a
                    [routerLink]="[
                      '/' + themeService.brand,
                      'product',
                      i.product.sku,
                    ]"
                  >
                    <img
                      class="image-aspect-ratio"
                      [alt]="i.product.sku"
                      [src]="
                        i.product.media
                          | productImageURL: settingNames.ProductImageSmall
                      "
                      vwProductImageFallback
                  /></a>
                </div>
                <div
                  class="d-flex flex-column flex-sm-row col-9 align-items-center"
                >
                  <div class="col-12 col-sm-5">
                    @if (
                      i.product.sku != null &&
                      shoppingCartService
                        .productExceptions()
                        .includes(i.product.sku)
                    ) {
                      <i class="fal fa-exclamation-triangle me-1"></i>
                    }
                    <a
                      [routerLink]="[
                        '/' + themeService.brand,
                        'product',
                        i.product.sku,
                      ]"
                    >
                      @if (!!i.product.productSubset?.length) {
                        <span class="d-block product-subset">{{
                          "productSubset" | translate
                        }}</span>
                      }
                      <span class="product-name">{{
                        i.product.media
                          | media
                            : mediaCategoryTypeNames.ProductName
                            : mediaTypes.Text
                      }}</span>
                    </a>
                  </div>
                  <div class="col-12 col-sm-3">
                    <div class="product-quantity">
                      @if (
                        i.shoppingCartItemId != null &&
                        i.quantity != null &&
                        (!i.product.minimumQuantity ||
                          i.quantity - 1 >= i.product.minimumQuantity)
                      ) {
                        <i
                          class="fal fa-minus"
                          (click)="decreaseQuantity(i.shoppingCartItemId)"
                        ></i>
                      }
                      @if (
                        i.shoppingCartItemId != null &&
                        i.quantity === i.product.minimumQuantity
                      ) {
                        <i
                          class="fal fa-trash-alt"
                          (click)="deleteItem(i.shoppingCartItemId)"
                        ></i>
                      }
                      <span class="me-2 ms-2">{{ i.quantity }}</span>
                      <i
                        class="fal fa-plus"
                        (click)="increaseQuantity($event, i.product)"
                        [class.disabled]="
                          i.quantity == null ||
                          (i.product.maximumQuantity &&
                            i.quantity + 1 > i.product.maximumQuantity)
                        "
                      ></i>
                    </div>
                  </div>
                  @if (
                    i.product.price != null &&
                    i.product.price.salesPrice != null
                  ) {
                    <div class="col-12 col-sm-4 text-start text-sm-end">
                      <div class="prices">
                        @if (
                          i.product.isCampaign && !!i.product.price.listPrice
                        ) {
                          <div class="product-campaign-prices">
                            @if (
                              i.product.price.adjustmentPercentage != null &&
                              i.product.price.salesPrice <
                                i.product.price.listPrice
                            ) {
                              <span class="percentage"
                                >{{
                                  i.product.price.adjustmentPercentage * 100
                                    | number: "1.0-0"
                                }}
                                {{ "price.discount" | translate }}</span
                              >
                            }
                            <span>{{
                              i.product.price.salesPrice
                                | price: false : i.quantity
                            }}</span>
                            @if (
                              i.product.price.salesPrice <
                              i.product.price.listPrice
                            ) {
                              <div
                                class="d-flex justify-content-end align-items-center"
                              >
                                <span class="original">{{
                                  i.product.price.listPrice
                                    | price: false : i.quantity
                                }}</span>
                                <i
                                  class="fal fa-info-circle"
                                  title="{{ 'price.latest' | translate }}"
                                ></i>
                              </div>
                            }
                          </div>
                        } @else {
                          <span>
                            {{
                              i.product.price.salesPrice
                                | price: false : i.quantity
                            }}
                          </span>
                        }
                        <span class="product-monthly-price">
                          {{
                            i.product.price.salesPrice
                              | price: true : i.quantity
                          }}
                        </span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (!i.product?.price && !!modelAndDealerService.selectedDealer) {
              <div class="row">
                <div class="col-12">
                  <i class="fal fa-exclamation-triangle me-2"></i>
                  <span>{{ "shoppingCart.noDealerPrice" | translate }}</span>
                </div>
              </div>
            }
            @if (
              !!campaignCodeResponse() &&
              !!campaignCodeResponse()!.isValidCampaignCode &&
              !!shoppingCartService.isCampaignCodeApplied() &&
              !campaignCodeResponse()!.campaignCodeDetails
                ?.isValidForCampaignProducts &&
              i.product?.isCampaign
            ) {
              <div class="col-12">
                <i class="fal fa-exclamation-triangle me-2"></i>
                <span>{{
                  "shoppingCart.campaignCode.productNotIncluded" | translate
                }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (
      shoppingCartService.hasItems() && modelAndDealerService.selectedDealer
    ) {
      <div class="price">
        <div>
          <span>{{ "price.price" | translate }}</span>
          @if (
            !!shoppingCartService.totalPriceOriginal() &&
            !!shoppingCartService.isCampaignCodeApplied()
          ) {
            <span class="ms-auto me-2 bold text-decoration-line-through"
              >{{ shoppingCartService.totalPriceOriginal() | price }}
            </span>
          }
          <span>{{ shoppingCartService.total() | price }}</span>
        </div>
        <div class="total">
          <span>{{ "shoppingCart.total" | translate }}</span>
          <div>
            <span class="bold">{{ shoppingCartService.total() | price }}</span>
            @if (shoppingCartService.total() >= 500) {
              <div class="d-flex align-items-center">
                <vw-brand-card class="mx-3"></vw-brand-card>
                <span class="bold monthly-total"
                  >{{ shoppingCartService.monthlyTotal() | price }} /
                  {{ "price.month" | translate }}</span
                >
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
